export default "__VITE_ASSET__CeFR1fPo__"